export const TIMELINE_SECTION_ID = 'timeline';
export const PAYMENT_INFO_SECTION_ID = 'payment-info';
export const OFFERS_AND_UPGRADES_SECTION_ID = 'offers-and-upgrades';
export const PRODUCTS_SECTION_ID = 'products';
export const OVO_FOUNDATION_FORM_SECTION_ID = 'ovo-foundation-form';
export const DD_CALCULATOR_SECTION_ID = 'dd-calculator';
export const RECOMMENDED_DD_SECTION_ID = 'recommended-dd';
export const REWARDS_SECTION_ID = 'rewards';
